export const en = {
  nav: {
    home: "Home",
    about: "About Us",
    services: "Services",
    contact: "Contact",
    toggle: "Toggle language",
  },
  hero: {
    tag: "Authorized Partners",
    title: "CNC Automation",
    subtitle: "Professional CNC Machine Service",
    desc: "Service of CNC machine tools from leading global manufacturers.",
    btnServices: "Our Services",
    btnContact: "Contact Us",
  },

  /* --- HOME --- */
  home: {
    offerTag: "Our Offer",
    offerTitle: "Comprehensive Service Solutions",
    offerDesc:
      "We provide specialized service, modernization, and inspection work for CNC machine tools and machining centers of the highest class.",
    services: [
      {
        name: "Installation after Relocation",
        desc: "Embedding, anchoring, precision leveling, and static geometry setup for machines after relocation. Spindle runout measurement.",
      },
      {
        name: "Electrical Diagnostics",
        desc: "Troubleshooting, replacement of encoders and inverters. We create and install interfaces, and we also calibrate tool probes.",
      },
      {
        name: "Mechanical Diagnostics",
        desc: "Geometry correction, axis backlash compensation. We replace guides, ball screws, and elements of pneumatic installations.",
      },
      {
        name: "Machine Inspections (PPM)",
        desc: "Comprehensive inspection of mechanisms and systems, filter/oil replacements according to the manufacturer, and parameter backups.",
      },
    ],
    learnMore: "Learn more",
    aboutTitle: "About Us & Our Experience",
    aboutDesc:
      "We have been working in the industry since 2007, developing our competencies in the diagnosis and repair of CNC machine tools. We are an official service partner of MAZAK and BLUM-Novotest.",
    aboutList: [
      "Experience in MAZAK factories since 2007",
      "Former authorized MAKINO Central Europe service",
      "Official partnership with MAZAK and BLUM-Novotest",
      "Specialization: FANUC, MITSUBISHI, HEIDENHAIN",
    ],
    contactTitle: "CNC Automation - Dariusz Król",
    contactDesc:
      "Call us or send an email to learn more about our services.",
    contactBtnMail: "kontakt@automatyka-cnc.pl",
    contactBtnPhone: "Call: +48 500 076 868",
  },

  /* --- SERVICES --- */
  uslugi: {
    tag: "Scope of our expertise",
    title: "Service from the Ground Up",
    desc: "We provide specialized, comprehensive service for cutting machines of the most popular brands, based on many years of work in MAZAK and MAKINO teams.",
    contactBtn: "Ask for a service quote",
    list: [
      {
        tag: "Relocation support",
        name: "Machine Installation after Relocation",
        desc: "Relocating production equipment is a critical and complex process. We make sure downtime is reduced to the necessary minimum, and that the commissioning of the relocated machine is efficient and fast, while maintaining readiness to immediately start precise and stable machining. We support the move throughout the entire path, from preparing and securing the machine for relocation to the first chip at the new location.",
        bullets: [
          "Seating the machine on the foundation and preparing anchoring",
          "Connection of machine peripheral devices",
          "Precision leveling",
          "Setting machine geometry after relocation",
          "Installing tool magazines, pallet changers, pallet stores",
        ],
      },
      {
        tag: "Unidentified alarms",
        name: "Electrical Fault Diagnostics",
        desc: "Unplanned machine downtime is always a worst‑case scenario that hits at the least convenient moment, exposing the company to financial losses and a loss of customer trust. We act immediately—we precisely diagnose the causes of alarms and hardware faults and eliminate them to promptly restore full technological continuity of your process.",
        bullets: [
          "Diagnostics and elimination of electrical faults causing alarms",
          "Replacement of drives, inverters, and encoders",
          "Correction of axis reference positions and ATC tool‑change positions",
          "Calibration of tool measurement systems and material probes",
          "Integration of additional optional external systems",
        ],
      },
      {
        tag: "Spindles & Geometry",
        name: "Mechanical Fault Diagnosis",
        desc: "Wear of the spindle or machine structural components progresses over time, regardless of us. In addition, collisions accelerate wear and almost always change machine geometry. We perform measurements and mechanical repairs of the most important subassemblies, including kinematic and hydraulic systems, and we also set machine geometry.",
        bullets: [
          "Measurement and adjustment of the machine’s static geometry",
          "Measurement of clamping force and milling spindle runout",
          "Checking and compensating axis backlash",
          "Replacement of guides and axis ball screws",
          "Diagnosis and replacement of hydraulic and pneumatic system components",
        ],
      },
      {
        tag: "Preventive Maintenance",
        name: "Periodic Machine Inspections (PPM)",
        desc: "Regular preventive inspections mean lower risk of serious equipment failures. We implement and cyclically monitor machine condition, the spindle, geometry, and backlash, and we replace filters, oils, batteries, and other consumables to keep the machine in optimal condition for years.",
        bullets: [
          "Inspection of machine systems, wiring, and mechanisms",
          "Measurement of geometry and ball‑screw backlash",
          "Check of the milling spindle condition",
          "Replacement of consumables according to manufacturer recommendations",
          "Creating parameter backups",
        ],
      },
    ],
  },

  /* --- ABOUT --- */
  onas: {
    headerTag: "Our History",
    title: "History of Our Experience",
    desc: "Since 2007, we have been continuously building our competencies on the largest factories and production lines, guided by Japanese installation precision.",
    paragraph1:
      "Our experience dates back to 2007 - working on the construction of Mazak machine tools on the production line in WORCESTER (UK). From 2011, work in the MAZAK PL service, and then from 2017 in the MAKINO Central Europe service. Since mid-2023, we have been conducting CNC machine service activities mainly for Japanese manufacturers, but not only. Currently, we are a service partner of ",
    paragraph2: " and a commercial and service partner of ",
    paragraph3: " companies.",
    pillarsTitle: "Foundations of cooperation:",
    pillars: [
      "Authorized MAZAK service partner",
      "Certified support and sales of BLUM-Novotest",
      "Experts in FANUC and MITSUBISHI systems",
      "Years of background in HEIDENHAIN environments",
    ],
    timeline: [
      {
        year: "2007",
        title: "Worcester, UK",
        description: "Working at the MAZAK machine tool factory on the production line. Foundation of Japanese precision.",
      },
      {
        year: "2011",
        title: "MAZAK Poland",
        description: "Joining the MAZAK PL service team. Intensive development of diagnostic competencies.",
      },
      {
        year: "2017",
        title: "MAKINO Central Europe",
        description: "Working in the MAKINO service. Specialization in advanced machining systems based on FANUC systems.",
      },
      {
        year: "2023",
        title: "CNC Automation",
        description: "Starting own business under the CNC Automation brand. Official MAZAK and BLUM partner status.",
      },
      {
        year: "2024",
        title: "Partnership with Mechatronika CNC",
        description: "Establishing a partnership with Mechatronika CNC in the field of servicing and mutual technical support.",
      },
    ],
    partnershipsTitle: "Authorized Partnerships",
    partnershipsDesc: "Our competencies are confirmed by direct collaboration with CNC industry leaders. We guarantee the highest quality of services in accordance with manufacturer standards.",
    partners: [
      {
        name: "MAZAK",
        role: "Official Service Partner",
        desc: "Years of experience in MAZAK factories and service since 2007.",
      },
      {
        name: "BLUM-Novotest",
        role: "Certified Commercial & Service Partner",
        desc: "Authorized technical support and sales of BLUM measurement systems.",
      },
    ],
    galleryTitle: "Project Gallery",
    galleryDesc: "See our daily work on the most demanding CNC systems. Precision and professionalism in every detail.",
  },

  /* --- CONTACT --- */
  kontakt: {
    title: "Contact Us",
    subtitle:
      "Do you have questions about CNC service, modernization, or machine relocation? Send us a message.",
    dataTitle: "Our Details",
    locationTitle: "Localization",
    locationValue: "Łukowica, Poland",
    phoneTitle: "Contact Phone",
    emailTitle: "E-mail Address",
    socialTitle: "Find us online:",
  },
  footer: {
    allRightsReserved: "All rights reserved.",
  },
} as const;
